export const PLAYLIST_CARD_CLICKED = 'playlist_card_clicked';
export const PLAYLIST_START_WATCHING_CLICKED =
  'playlist_start_watching_clicked';
export const PREVIEW_THUMBNAIL = 'preview_thumbnail';
export const MAIN_CTA = 'main_CTA';
export const PLAYLIST_DETAILS_PAGE = 'Playlist_details_page';
export const CLASS_CARD = 'class_card';
export const SIDE_CARD = 'side_card';
export const PLAY_BUTTON = 'play_button';
export const EDUCATOR_PROFILE_PLAYLIST_SEE_ALL =
  'Educator profile playlist see all';
export const SPECIAL_CLASS_PLAYLIST_SEE_ALL = 'Special class playlist see all';
export const EDUCATOR_PROFILE = 'Educator Profile';
export const SPECIAL_CLASS_BROWSE_PAGE = 'Special class browse page';
